export function resolveMediaUrl(media) {
    if (!media) return '';
    if (media.includes('pexxxels.com/')) {
        const encoded = encodeURIComponent(media);
        let prefix = '';
        if (import.meta.env.VITE_IS_PREVIEW_SERVER === 'true'){
            prefix = '/api/preview'
        }

        return `${prefix}/api/proxy/pexels?url=${encoded}`;
    }
    return media;
}

const locateFile = (pexels, quality, width) => {
    // The exact width first: Pexels lists several 'hd' files and the first is often 1280 wide.
    return pexels?.video_files.find(p => p.width === width) ||
        pexels?.video_files.find(p => p.quality === quality) || pexels
}

export function resolveVideo(media) {
    if (!media) return '';
    if (media.link.includes('pexels.com/')) {
        const url = locateFile(media.pexels, 'hd', 1920)?.link;
        const encoded = encodeURIComponent(url);
        let prefix = '';
        if (import.meta.env.VITE_IS_PREVIEW_SERVER === 'true'){
            prefix = '/api/preview'
        }

        return `${prefix}/api/proxy/pexels?url=${encoded}`;
    }
    if (media.link !== '')
        return media.link
    return media.url;
}